export default __webpack_public_path__ + "assets/img/GreenTickIcon.5673c8a2.svg";